import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { Icon, Input } from '@ibk/shared-ui';
import styles from './BeneficiaryFilters.module.css';
const SEARCH_DEBOUNCE_DELAY = 300;
export const BeneficiaryFilters = ({ searchTerm, onSearchChange, testIdIdentifier, placeholder, debounceDelay = SEARCH_DEBOUNCE_DELAY, }) => {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = useState(searchTerm);
    const isUserInputRef = useRef(false);
    useEffect(() => {
        if (!isUserInputRef.current) {
            setInputValue(searchTerm);
        }
    }, [searchTerm]);
    useEffect(() => {
        if (!isUserInputRef.current) {
            return undefined;
        }
        const timer = setTimeout(() => {
            isUserInputRef.current = false;
            onSearchChange(inputValue);
        }, debounceDelay);
        return () => clearTimeout(timer);
    }, [inputValue, onSearchChange, debounceDelay]);
    const inputTestId = testIdIdentifier ? `input${testIdIdentifier}Search` : 'beneficiaries-search-input';
    const clearTestId = testIdIdentifier ? `button${testIdIdentifier}ClearSearch` : 'beneficiaries-clear-search';
    const handleChange = (e) => {
        isUserInputRef.current = true;
        setInputValue(e.target.value);
    };
    const handleClear = () => {
        isUserInputRef.current = false;
        setInputValue('');
        onSearchChange('');
    };
    return (_jsx("div", { className: styles.container, children: _jsx("div", { className: styles.searchContainer, children: _jsx(Input, { placeholder: placeholder ?? t('benefits.beneficiaries.search-placeholder'), value: inputValue, onChange: handleChange, dataTestId: inputTestId, size: 'small', leftElement: _jsx(Icon, { name: 'search', className: styles.searchIcon }), rightElement: inputValue ? (_jsx("button", { type: 'button', className: styles.clearButton, onClick: handleClear, "data-testid": clearTestId, "aria-label": t('benefits.beneficiaries.clear-search'), children: _jsx(Icon, { name: 'circleXmark', variant: 'mask', tintColor: 'var(--icon-neutral-stronger)', className: styles.clearIcon }) })) : undefined }) }) }));
};
